module.exports = __webpack_public_path__ + "img/separator8.27a60f64.svg";